// @ts-check
export const config={
  NAME:"Sellplat",
  BASE_URL:import.meta.env.VITE_API_URL,
  IMG_DELIVERY:"https://imagedelivery.net/K6bNIi4XITxUPMPcb-sFlw",
  HOSTNAME:import.meta.env.VITE_SITE_URL,
  RESERVED_TITLES:["home","blog"],
  SPLITTER:"|*|",
  SPLITTER2:"|**|",
  AUTH_TOKEN_MAX_TIME:180,
  DEFAULT_PLACEHOLDER:'https://r2.senplat.com/public/image/sp_placeholder.png',
  ICONS:['bi-card-image','bi-alexa','bi-asterisk','bi-award','bi-balloon-heart'],
 ACTIVE_THEME:["Default","Blue","Green","Red","Yellow"],
THEMES:{
  blue: {
  "--sp-primary":"#2563eb",
  "--sp-hover":"#1134a6",
  "--sp-subtle":"#cff4fc",
  "--sp-footer":"#1134a6" //same as hover for now, darker...
  },
  green: {
  "--sp-primary":"#379237",
  "--sp-hover":"#0b4008",
  "--sp-subtle":"#d1e7dd",
  "--sp-footer":"#0b4008" //same as hover for now, darker...
  },
  red: {
 "--sp-primary":"#ff5757",
  "--sp-hover":"#7c0a02",
  "--sp-subtle":"#f8d7da",
  "--sp-footer":"#7c0a02" //same as hover for now, darker...
  },

  purple: {
  "--sp-primary":"#7c3aed",
  "--sp-primary-hover":"#6d28d9",
  },
  yellow: {
  "--sp-primary":"#EFB300",
  "--sp-hover":"#e47200",
  "--sp-subtle":"#fff3cd",
  "--sp-footer":"#000B26" // different
  },
  orange:{
  "--sp-primary":"#f97316",
  "--sp-primary-hover":"#ea580c",
  }
  },


  THEMES2:{
  
  default:{
  "--sp-primary":"#2563eb",
  "--sp-primary-hover":"#1d4ed8",
  "--sp-bg":"#ffffff",
  "--sp-card":"#f9fafb",
  "--sp-text":"#111827",
  "--sp-muted":"#6b7280",
  "--sp-link":"#2563eb",
  "--sp-link-hover":"#1d4ed8",
  "--sp-border":"#e5e7eb",
  },
  blue: {
  "--sp-primary":"#2563eb",
  "--sp-primary-hover":"#1d4ed8",
  },
  green: {
  "--sp-primary":"#10b981",
  "--sp-primary-hover":"#059669",
  },
  red: {
 "--sp-primary":"#ef4444",
  "--sp-primary-hover":"#dc2626",
  },

  purple: {
  "--sp-primary":"#7c3aed",
  "--sp-primary-hover":"#6d28d9",
  },
  yellow: {

  },
  orange:{
  "--sp-primary":"#f97316",
  "--sp-primary-hover":"#ea580c",
  }
  },
  
  SIDEBAR_LAYOUT:["NONE","LEFT", "RIGHT"],
  CONTENT_STATUS :["PUBLISH","DRAFT","TRASH"],
  POST_TYPE :["POST","PAGE","PRODUCT","COURSE","EVENT"],
  ROLES :["CONTRIBUTOR","AUTHOR","EDITOR"],
  //##########
  ALERT_TYPE:["alert-success", "alert-warning", "alert-danger"],
  ICON_FILL:["#198754", "#ffc107", "#dc3545"],
  FORMAT_CLASZ:{"spb":"spb","spi":"spi","spu":"spu","sps":"sps"},
  ERROR_MESSAGE: 'An unexpected error occurred',
  //######
  VALIDATION_CLASS:['border','border-danger'],
  INITIAL_TEXT:"God wants you well. Understanding and living according to God’s plan is the key to life’s fulfillment."
};